import { compareStoresByPriority } from "./personal-filters";
import type { Catalog } from "./types";

export function orderCatalogLibraryCatalogs(
  catalogs: readonly Catalog[],
  locale: string,
): Catalog[] {
  return [...catalogs].sort(
    (left, right) =>
      compareStoresByPriority(left.chain, right.chain, locale) ||
      right.valid_from.localeCompare(left.valid_from) ||
      left.valid_until.localeCompare(right.valid_until) ||
      left.title.localeCompare(right.title, locale),
  );
}
